"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useUser } from "@/context/UserProvider";
import AuthCard from "@/components/AuthCard";

export default function Login() {
	const { isLoggedIn, isLoading } = useUser();
	const router = useRouter();

	useEffect(() => {
		// If user is already logged in, redirect to intended path or home
		if (!isLoading && isLoggedIn) {
			const intendedPath = sessionStorage.getItem("intendedPath");
			sessionStorage.removeItem("intendedPath");
			router.push(intendedPath || "/studio/dashboard");
		}
	}, [isLoggedIn, isLoading, router]);

	// Show loading or redirect if already logged in
	if (isLoading || isLoggedIn) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-sm text-muted-foreground">Loading...</div>
			</div>
		);
	}

	return (
		<div className="h-full flex flex-col items-center justify-center relative py-12">


			<AuthCard />
		</div>
	);
}
